import { Component, OnInit, Input, Inject, PLATFORM_ID, OnDestroy, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { isPlatformServer } from "@angular/common";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { Subscription } from "rxjs";
import { ApiService } from "../../services/api.service";
import Swiper from "swiper";

@Component({
    selector: "app-contact-form-lite",
    templateUrl: "./contact-form-lite.component.html",
    styleUrls: ["./contact-form-lite.component.scss"],
})
export class ContactFormLiteComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() rendering: ComponentRendering;
    @ViewChild("FormLite", { static: false }) formSlider!: ElementRef;
    form: FormGroup;
    _isPlatformServer: boolean = false;
    public maskStringWithSpace: {} = { mask: /^([\p{L}]+(?:\p{Z})*)*?$/u };
    public maskNumber: {} = { mask: /^\d*$/ };
    private reCaptchaSubscription: Subscription;
    public LoadingOnSubmit: boolean = false;
    callSuccess: boolean;
    swiper: Swiper;

    constructor(@Inject(PLATFORM_ID) public readonly platformId: string, private fb: FormBuilder, private recaptchaV3Service: ReCaptchaV3Service, protected apiService: ApiService) {
        platformId;
    }

    ngOnInit() {
        this._isPlatformServer = isPlatformServer(this.platformId);

        if (!this._isPlatformServer) {
            this.form = this.fb.group({
                name: ["", Validators.required],
                surname: ["", Validators.required],
                phone: [""],
                email: [
                    "",
                    [
                        Validators.required,
                        Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
                    ],
                ],
                area: ["", Validators.required],
            });
        }
    }

    ngAfterViewInit(): void {
        if (!this._isPlatformServer) {
            this.swiper = new Swiper(this.formSlider.nativeElement, {
                spaceBetween: 4,
                autoHeight: true,
                allowTouchMove: false,
            });

            const resizeObserver = new ResizeObserver(() => {
                this.swiper.update();
            });

            resizeObserver.observe(document.getElementById("contactform-lite-area"));
        }
    }

    ngOnDestroy(): void {
        if (this.reCaptchaSubscription) {
            this.reCaptchaSubscription.unsubscribe();
        }
    }

    isInputInvalid(controlName: string): boolean {
        return this.form.get(controlName).invalid && this.form.get(controlName).touched;
    }

    Submit() {
        if (!this._isPlatformServer) {
            if (this.form.invalid) {
                this.form.markAllAsTouched();
            } else {
                this.LoadingOnSubmit = true;
                this.reCaptchaSubscription = this.recaptchaV3Service.execute("formSubmission").subscribe((token) => {
                    var request = {
                        Name: this.form?.controls?.name?.value,
                        Surname: this.form?.controls?.surname?.value,
                        Area: this.form?.controls?.area?.value,
                        Telephone: this.form?.controls?.phone?.value,
                        Email: this.form?.controls?.email?.value,
                        Url: document?.location?.href,
                        reCaptchaV3Token: token,
                        EmailFrom: (this.rendering?.fields?.EmailFrom as any)?.value,
                        EmailTo: (this.rendering?.fields?.EmailTo as any)?.value,
                    };

                    this.apiService
                        .fetch<any>("/piraeusapi/forms/contactForm/submitcontactform", request)
                        .then((resp) => {
                            if (resp.status === 200) {
                                this.callSuccess = true;
                            }
                        })
                        .finally(() => {
                            this.swiper.slideNext();
                            this.LoadingOnSubmit = false;
                        });
                });
            }
        }
    }
}
